import Avatar from '@website/components/directoryTheme/Avatar';
import TrustPilotWidget from '@website/components/trustpilot/TrustPilotWidget';
import { GroupForBookingFormQuery } from '@website/types/graphqlOperations';
import { Alert, Col, Row } from 'react-bootstrap';

type Props = {
  guests: GroupForBookingFormQuery['group']['guests']['items'];
};

export default function CheckoutGuestsOnGroup({ guests }: Props) {
  if (guests.length === 0) {
    return null;
  }

  // Sort guests to put those with profile pictures first
  const sortedGuests = [...guests].sort(
    (a, b) =>
      Number(!!b.user?.picture?.file?.key) -
      Number(!!a.user?.picture?.file?.key),
  );

  return (
    <>
      <Alert variant="success" className="text-sm mb-0 mt-4">
        <Row>
          <Col xs={12}>
            <strong>You're joining a small-group trip</strong>
            <br />
            There{' '}
            {guests.length === 1
              ? `is 1 other person`
              : `are ${guests.length} other people`}{' '}
            booked on already.{' '}
            {guests.length > 14
              ? 'This trip may be split into smaller groups.'
              : ''}
          </Col>
          <Col className="d-flex flex-wrap mt-2 mx-auto" xs={12}>
            {sortedGuests.slice(0, 13).map((guest) => (
              <div
                key={guest.id}
                style={{
                  ...{ marginRight: '-15px' },
                }}
              >
                <Avatar
                  size="md"
                  image={
                    guest.user?.picture?.file?.key ?? guest.picture?.file?.key
                  }
                  border
                  alt={guest.user?.givenName ?? guest.givenName}
                />
              </div>
            ))}
          </Col>
        </Row>
      </Alert>
      <div className="mt-2">
        <TrustPilotWidget
          templateId="5419b6ffb0d04a076446a9af"
          height="20px"
          className="my-4 d-block d-md-none"
        />
      </div>
    </>
  );
}
